var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"city-main"},[_vm._v(_vm._s(_vm.info.city_name)),_c('div',{staticClass:"address_bottom"},[_vm._v(_vm._s(_vm.info.city_code_gp)+" "+_vm._s(_vm.info.is_cn ? '' : _vm.info.country_name_cn))])])
}
var staticRenderFns = []

export { render, staticRenderFns }